
import { fetchGetAuth } from "../../utils/utils";
import { authActions } from "./auth-slice";

export const login = () => {
    window.location.href = `${window.config.authApiUrl}/auth/eduidp?next=${window.config?.virtualSchoolLink}`;
}

export const checkLogin = () => {
    return async (dispatch) => {
        try {
            let res = await fetch(`${window.config.authApiUrl}/auth/my`, {
                credentials: "include"
            });
            let data = await res.json();
            dispatch(authActions.init({ ...data, initAuthDetails: !data.isAuth }))
            if (data.isAuth)
                dispatch(getUserDetails())


        }
        catch {
            dispatch(authActions.init({ isAuth: false, initAuthDetails: true }))
        }
    }
}


export const getUserDetails = () => {
    return async (dispatch) => {
        try {
            let resUserFilter = await fetchGetAuth(`${window.config.authApiUrl}/api/user/filter?getMainClass=true`);
            let selectedSchool;
            if (resUserFilter) {
                const schoolIdFromUrl = new URLSearchParams(window.location.search).get('schoolId');
                if (schoolIdFromUrl) {
                    if (resUserFilter.defaultSchool && Number(resUserFilter.defaultSchool.id) === Number(schoolIdFromUrl)) {
                        selectedSchool = resUserFilter.defaultSchool;
                    }
                    else if (resUserFilter.schools) {
                        selectedSchool = resUserFilter.schools.find(s => Number(s.id) === Number(schoolIdFromUrl));
                    }
                }
                if (!selectedSchool) {
                    if (resUserFilter.defaultSchool) {
                        selectedSchool = resUserFilter.defaultSchool;
                    }
                    else if (resUserFilter.schools && resUserFilter.schools.length > 0) {
                        selectedSchool = resUserFilter.schools[0];
                    }
                }
            }
            else {
                selectedSchool = {};
                resUserFilter = { genderId: 0 };
            }
            dispatch(authActions.setUserDetailsAndSchool({ userDetails: resUserFilter, school: selectedSchool ?? {} }));

        }
        catch {
            dispatch(authActions.init({ isAuth: false, initAuthDetails: true }))
        }
    }
}

export const logout = () => {
    window.location.href = `${window.config.authApiUrl}/auth/logout?next=${window.config.logoutRedirectUri}`;
}